import React, { useId } from 'react'
import PropTypes from 'prop-types'

const CopyIcon = React.forwardRef(function CopyIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 2C2.90228 2 2 2.90228 2 4 2 4.55228 1.55228 5 1 5 .447715 5 0 4.55228 0 4 0 1.79772 1.79772 0 4 0 4.55228 0 5 .447715 5 1 5 1.55228 4.55228 2 4 2ZM1 7C1.55228 7 2 7.44772 2 8V10.14C2 10.6923 1.55228 11.14 1 11.14.447715 11.14 0 10.6923 0 10.14V8C0 7.44772.447715 7 1 7ZM1 13C1.55228 13 2 13.4477 2 14 2 15.0977 2.90228 16 4 16 4.55228 16 5 16.4477 5 17 5 17.5523 4.55228 18 4 18 1.79772 18 0 16.2023 0 14 0 13.4477.447715 13 1 13ZM13 1C13 .447715 13.4477 0 14 0 16.2023 0 18 1.79772 18 4 18 4.55228 17.5523 5 17 5 16.4477 5 16 4.55228 16 4 16 2.90228 15.0977 2 14 2 13.4477 2 13 1.55228 13 1ZM7 1C7 .447715 7.44772 0 8 0H9.95C10.5023 0 10.95.447715 10.95 1 10.95 1.55228 10.5023 2 9.95 2H8C7.44772 2 7 1.55228 7 1ZM19 7C19 6.44772 19.4477 6 20 6 22.2023 6 24 7.79772 24 10V20C24 22.2023 22.2023 24 20 24H10C7.79772 24 6 22.2023 6 20 6 19.4477 6.44772 19 7 19 7.55228 19 8 19.4477 8 20 8 21.0977 8.90228 22 10 22H20C21.0977 22 22 21.0977 22 20V10C22 8.90228 21.0977 8 20 8 19.4477 8 19 7.55228 19 7Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.46289 6.46289C6.85342 6.07237 7.48658 6.07237 7.8771 6.46289L16.5371 15.1229C16.9276 15.5134 16.9276 16.1466 16.5371 16.5371C16.1466 16.9276 15.5134 16.9276 15.1229 16.5371L6.46289 7.8771C6.07237 7.48658 6.07237 6.85342 6.46289 6.46289Z"
        ></path>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 6H13C13.5523 6 14 6.44772 14 7C14 7.55228 13.5523 8 13 8H8V13C8 13.5523 7.55228 14 7 14C6.44772 14 6 13.5523 6 13V6Z"
        ></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

CopyIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CopyIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default CopyIcon
